import { App } from 'vue';
import Sheet from '@/components/ui/Sheet.vue';

export default {
  install(app: App) {
    app.component('Sheet', Sheet);
  },
};
